'use strict'

import ReactGA from 'react-ga';

const initialize = () => {
  ReactGA.initialize('UA-138679101-1');
  console.log('Initialized GA');
}

export { initialize };